import { useKanban } from "components/kanban/kanban-context";
import { funcFormatCurrency } from "functions/funcFormatCurrency";
import React from "react";
import { useDispatch } from "react-redux";
import { handleShowDetail } from "store/kanbanReducer/kanbanSlice";

const ItemKanbanLead = props => {
	const {
		provided,
		innerRef,
		handleDeleteKanban,
		style,
		data,
	} = useKanban();
	const { id, name, account, money, contact } = data
	const dispatch = useDispatch()
	const handleDetailKanban = () => {
		dispatch(handleShowDetail(data));
	}
	return (
		<div
			{...provided.draggableProps}
			{...provided.dragHandleProps}
			ref={innerRef}
			style={style}
			className="kanban-task-item bg-white px-3 py-3 border border-[#DDDDDD] ui-sortable-handle">
			<div className="flex items-center justify-between mb-2">
				<div
					className="hover:text-blue-2 transition-all title text-sm font-bold cursor-pointer"
					onClick={handleDetailKanban}>
					{name}
				</div>
				<div className="kanban-edit text-gray-1 relative hover:text-blue-2 transition-all">
					<div className="cursor-pointer flex">
						<em className="fa-solid fa-ellipsis"></em>
					</div>
					<ul className="kanban-edit-list bg-white px-10px py-10px gap-y-1 flex flex-col absolute top-full right-0 opacity-0 transition-all invisible shadow-[0px_4px_10px_rgba(0,0,0,0.15)]">
						<li>
							<div
								className="flex items-center gap-x-2 text-sm group"
								href="">
								<em className="fa-solid fa-pen text-gray-1 font-sm transition-all group-hover:text-primary"></em>
								<span className="text-gray-s2">Sửa</span>
							</div>
						</li>
						<li>
							<div
								onClick={handleDeleteKanban(id)}
								className="flex items-center gap-x-2 text-sm group">
								<em className="fa-solid fa-trash-can text-gray-1 font-sm transition-all group-hover:text-primary"></em>
								<span className="text-gray-s2">Xóa</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<ul className="text-sm leading-2">
				<li>Acc: {account}</li>
				<li>
					Est. cost:
					<span className="text-primary font-semibold">
						{" "}
						{funcFormatCurrency(money)}
					</span>
				</li>
				<li>Người liên hệ: {contact}</li>
			</ul>
		</div>
	);
};

export default ItemKanbanLead;
